"use client";

import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["__demoMode"],
  _excluded2 = ["id", "disabled", "autoFocus"],
  _excluded3 = ["id", "transition"],
  _excluded4 = ["id", "focus", "anchor", "portal", "modal", "transition"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFocusRing as Oe } from "@react-aria/focus";
import { useHover as Le } from "@react-aria/interactions";
import y, { createContext as te, createRef as ie, useContext as oe, useEffect as re, useMemo as I, useReducer as Ie, useRef as X, useState as ge } from "react";
import { useActivePress as De } from '../../hooks/use-active-press.js';
import { useElementSize as he } from '../../hooks/use-element-size.js';
import { useEvent as A } from '../../hooks/use-event.js';
import { useEventListener as ke } from '../../hooks/use-event-listener.js';
import { useId as ne } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as Ge } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as Se } from '../../hooks/use-latest-value.js';
import { useOnDisappear as He } from '../../hooks/use-on-disappear.js';
import { useOutsideClick as Ue } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as de } from '../../hooks/use-owner.js';
import { useResolveButtonType as Ne } from '../../hooks/use-resolve-button-type.js';
import { MainTreeProvider as Ae, useMainTreeNode as we, useRootContainers as Ke } from '../../hooks/use-root-containers.js';
import { useScrollLock as We } from '../../hooks/use-scroll-lock.js';
import { optionalRef as je, useSyncRefs as q } from '../../hooks/use-sync-refs.js';
import { Direction as h, useTabDirection as Ce } from '../../hooks/use-tab-direction.js';
import { transitionDataAttributes as Be, useTransition as Re } from '../../hooks/use-transition.js';
import { CloseProvider as Ve } from '../../internal/close-provider.js';
import { FloatingProvider as $e, useFloatingPanel as Je, useFloatingPanelProps as Xe, useFloatingReference as qe, useResolvedAnchor as ze } from '../../internal/floating.js';
import { Hidden as Pe, HiddenFeatures as fe } from '../../internal/hidden.js';
import { OpenClosedProvider as Ye, ResetOpenClosedProvider as Qe, State as z, useOpenClosed as _e } from '../../internal/open-closed.js';
import { isDisabledReactIssue7711 as Fe } from '../../utils/bugs.js';
import { Focus as k, FocusResult as ce, FocusableMode as Ze, focusIn as w, getFocusableElements as ve, isFocusableElement as et } from '../../utils/focus-management.js';
import { match as K } from '../../utils/match.js';
import '../../utils/micro-task.js';
import { getOwnerDocument as tt } from '../../utils/owner.js';
import { RenderFeatures as le, forwardRefWithAs as Y, mergeProps as Te, render as ee, useMergeRefsFn as ot } from '../../utils/render.js';
import { Keys as W } from '../keyboard.js';
import { Portal as rt, useNestedPortals as nt } from '../portal/portal.js';
var lt = function (P) {
    return P[P.Open = 0] = "Open", P[P.Closed = 1] = "Closed", P;
  }(lt || {}),
  at = function (s) {
    return s[s.TogglePopover = 0] = "TogglePopover", s[s.ClosePopover = 1] = "ClosePopover", s[s.SetButton = 2] = "SetButton", s[s.SetButtonId = 3] = "SetButtonId", s[s.SetPanel = 4] = "SetPanel", s[s.SetPanelId = 5] = "SetPanelId", s;
  }(at || {});
var pt = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 0, function _(t) {
    return _objectSpread(_objectSpread({}, t), {}, {
      popoverState: K(t.popoverState, _defineProperty(_defineProperty({}, 0, 1), 1, 0)),
      __demoMode: !1
    });
  }), 1, function _(t) {
    return t.popoverState === 1 ? t : _objectSpread(_objectSpread({}, t), {}, {
      popoverState: 1,
      __demoMode: !1
    });
  }), 2, function _(t, l) {
    return t.button === l.button ? t : _objectSpread(_objectSpread({}, t), {}, {
      button: l.button
    });
  }), 3, function _(t, l) {
    return t.buttonId === l.buttonId ? t : _objectSpread(_objectSpread({}, t), {}, {
      buttonId: l.buttonId
    });
  }), 4, function _(t, l) {
    return t.panel === l.panel ? t : _objectSpread(_objectSpread({}, t), {}, {
      panel: l.panel
    });
  }), 5, function _(t, l) {
    return t.panelId === l.panelId ? t : _objectSpread(_objectSpread({}, t), {}, {
      panelId: l.panelId
    });
  }),
  me = te(null);
me.displayName = "PopoverContext";
function ae(t) {
  var l = oe(me);
  if (l === null) {
    var P = new Error("<".concat(t, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(P, ae), P;
  }
  return l;
}
var pe = te(null);
pe.displayName = "PopoverAPIContext";
function ye(t) {
  var l = oe(pe);
  if (l === null) {
    var P = new Error("<".concat(t, " /> is missing a parent <Popover /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(P, ye), P;
  }
  return l;
}
var Ee = te(null);
Ee.displayName = "PopoverGroupContext";
function xe() {
  return oe(Ee);
}
var se = te(null);
se.displayName = "PopoverPanelContext";
function st() {
  return oe(se);
}
function ut(t, l) {
  return K(l.type, pt, t, l);
}
var it = "div";
function dt(t, l) {
  var f;
  var _t$__demoMode = t.__demoMode,
    P = _t$__demoMode === void 0 ? !1 : _t$__demoMode,
    R = _objectWithoutProperties(t, _excluded),
    T = X(null),
    C = q(l, je(function (o) {
      T.current = o;
    })),
    s = X([]),
    n = Ie(ut, {
      __demoMode: P,
      popoverState: P ? 0 : 1,
      buttons: s,
      button: null,
      buttonId: null,
      panel: null,
      panelId: null,
      beforePanelSentinel: ie(),
      afterPanelSentinel: ie(),
      afterButtonSentinel: ie()
    }),
    _n = _slicedToArray(n, 2),
    _n$ = _n[0],
    c = _n$.popoverState,
    i = _n$.button,
    r = _n$.buttonId,
    d = _n$.panel,
    _ = _n$.panelId,
    m = _n$.beforePanelSentinel,
    E = _n$.afterPanelSentinel,
    u = _n$.afterButtonSentinel,
    a = _n[1],
    v = de((f = T.current) != null ? f : i),
    L = I(function () {
      if (!i || !d) return !1;
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll("body > *")),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var M = _step.value;
          if (Number(M == null ? void 0 : M.contains(i)) ^ Number(M == null ? void 0 : M.contains(d))) return !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var o = ve(),
        e = o.indexOf(i),
        p = (e + o.length - 1) % o.length,
        g = (e + 1) % o.length,
        S = o[p],
        B = o[g];
      return !d.contains(S) && !d.contains(B);
    }, [i, d]),
    F = Se(r),
    G = Se(_),
    j = I(function () {
      return {
        buttonId: F,
        panelId: G,
        close: function close() {
          return a({
            type: 1
          });
        }
      };
    }, [F, G, a]),
    b = xe(),
    D = b == null ? void 0 : b.registerPopover,
    H = A(function () {
      var o;
      return (o = b == null ? void 0 : b.isFocusWithinPopoverGroup()) != null ? o : (v == null ? void 0 : v.activeElement) && ((i == null ? void 0 : i.contains(v.activeElement)) || (d == null ? void 0 : d.contains(v.activeElement)));
    });
  re(function () {
    return D == null ? void 0 : D(j);
  }, [D, j]);
  var _nt = nt(),
    _nt2 = _slicedToArray(_nt, 2),
    O = _nt2[0],
    V = _nt2[1],
    U = we(i),
    N = Ke({
      mainTreeNode: U,
      portals: O,
      defaultContainers: [i, d]
    });
  ke(v == null ? void 0 : v.defaultView, "focus", function (o) {
    var e, p, g, S, B, M;
    o.target !== window && o.target instanceof HTMLElement && c === 0 && (H() || i && d && (N.contains(o.target) || (p = (e = m.current) == null ? void 0 : e.contains) != null && p.call(e, o.target) || (S = (g = E.current) == null ? void 0 : g.contains) != null && S.call(g, o.target) || (M = (B = u.current) == null ? void 0 : B.contains) != null && M.call(B, o.target) || a({
      type: 1
    })));
  }, !0), Ue(c === 0, N.resolveContainers, function (o, e) {
    a({
      type: 1
    }), et(e, Ze.Loose) || (o.preventDefault(), i == null || i.focus());
  });
  var x = A(function (o) {
      a({
        type: 1
      });
      var e = function () {
        return o ? o instanceof HTMLElement ? o : "current" in o && o.current instanceof HTMLElement ? o.current : i : i;
      }();
      e == null || e.focus();
    }),
    $ = I(function () {
      return {
        close: x,
        isPortalled: L
      };
    }, [x, L]),
    J = I(function () {
      return {
        open: c === 0,
        close: x
      };
    }, [c, x]),
    Z = {
      ref: C
    };
  return y.createElement(Ae, {
    node: U
  }, y.createElement($e, null, y.createElement(se.Provider, {
    value: null
  }, y.createElement(me.Provider, {
    value: n
  }, y.createElement(pe.Provider, {
    value: $
  }, y.createElement(Ve, {
    value: x
  }, y.createElement(Ye, {
    value: K(c, _defineProperty(_defineProperty({}, 0, z.Open), 1, z.Closed))
  }, y.createElement(V, null, ee({
    ourProps: Z,
    theirProps: R,
    slot: J,
    defaultTag: it,
    name: "Popover"
  })))))))));
}
var Pt = "button";
function ft(t, l) {
  var P = ne(),
    _t$id = t.id,
    R = _t$id === void 0 ? "headlessui-popover-button-".concat(P) : _t$id,
    _t$disabled = t.disabled,
    T = _t$disabled === void 0 ? !1 : _t$disabled,
    _t$autoFocus = t.autoFocus,
    C = _t$autoFocus === void 0 ? !1 : _t$autoFocus,
    s = _objectWithoutProperties(t, _excluded2),
    _ae = ae("Popover.Button"),
    _ae2 = _slicedToArray(_ae, 2),
    n = _ae2[0],
    c = _ae2[1],
    _ye = ye("Popover.Button"),
    i = _ye.isPortalled,
    r = X(null),
    d = "headlessui-focus-sentinel-".concat(ne()),
    _ = xe(),
    m = _ == null ? void 0 : _.closeOthers,
    u = st() !== null;
  re(function () {
    if (!u) return c({
      type: 3,
      buttonId: R
    }), function () {
      c({
        type: 3,
        buttonId: null
      });
    };
  }, [u, R, c]);
  var _ge = ge(function () {
      return Symbol();
    }),
    _ge2 = _slicedToArray(_ge, 1),
    a = _ge2[0],
    v = q(r, l, qe(), u ? null : function (e) {
      if (e) n.buttons.current.push(a);else {
        var p = n.buttons.current.indexOf(a);
        p !== -1 && n.buttons.current.splice(p, 1);
      }
      n.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), e && c({
        type: 2,
        button: e
      });
    }),
    L = q(r, l),
    F = de(r),
    G = A(function (e) {
      var p, g, S;
      if (u) {
        if (n.popoverState === 1) return;
        switch (e.key) {
          case W.Space:
          case W.Enter:
            e.preventDefault(), (g = (p = e.target).click) == null || g.call(p), c({
              type: 1
            }), (S = n.button) == null || S.focus();
            break;
        }
      } else switch (e.key) {
        case W.Space:
        case W.Enter:
          e.preventDefault(), e.stopPropagation(), n.popoverState === 1 && (m == null || m(n.buttonId)), c({
            type: 0
          });
          break;
        case W.Escape:
          if (n.popoverState !== 0) return m == null ? void 0 : m(n.buttonId);
          if (!r.current || F != null && F.activeElement && !r.current.contains(F.activeElement)) return;
          e.preventDefault(), e.stopPropagation(), c({
            type: 1
          });
          break;
      }
    }),
    j = A(function (e) {
      u || e.key === W.Space && e.preventDefault();
    }),
    b = A(function (e) {
      var p, g;
      Fe(e.currentTarget) || T || (u ? (c({
        type: 1
      }), (p = n.button) == null || p.focus()) : (e.preventDefault(), e.stopPropagation(), n.popoverState === 1 && (m == null || m(n.buttonId)), c({
        type: 0
      }), (g = n.button) == null || g.focus()));
    }),
    D = A(function (e) {
      e.preventDefault(), e.stopPropagation();
    }),
    _Oe = Oe({
      autoFocus: C
    }),
    H = _Oe.isFocusVisible,
    O = _Oe.focusProps,
    _Le = Le({
      isDisabled: T
    }),
    V = _Le.isHovered,
    U = _Le.hoverProps,
    _De = De({
      disabled: T
    }),
    N = _De.pressed,
    Q = _De.pressProps,
    x = n.popoverState === 0,
    $ = I(function () {
      return {
        open: x,
        active: N || x,
        disabled: T,
        hover: V,
        focus: H,
        autofocus: C
      };
    }, [x, V, H, N, T, C]),
    J = Ne(t, r),
    Z = u ? Te({
      ref: L,
      type: J,
      onKeyDown: G,
      onClick: b,
      disabled: T || void 0,
      autoFocus: C
    }, O, U, Q) : Te({
      ref: v,
      id: n.buttonId,
      type: J,
      "aria-expanded": n.popoverState === 0,
      "aria-controls": n.panel ? n.panelId : void 0,
      disabled: T || void 0,
      autoFocus: C,
      onKeyDown: G,
      onKeyUp: j,
      onClick: b,
      onMouseDown: D
    }, O, U, Q),
    f = Ce(),
    o = A(function () {
      var e = n.panel;
      if (!e) return;
      function p() {
        K(f.current, _defineProperty(_defineProperty({}, h.Forwards, function () {
          return w(e, k.First);
        }), h.Backwards, function () {
          return w(e, k.Last);
        })) === ce.Error && w(ve().filter(function (S) {
          return S.dataset.headlessuiFocusGuard !== "true";
        }), K(f.current, _defineProperty(_defineProperty({}, h.Forwards, k.Next), h.Backwards, k.Previous)), {
          relativeTo: n.button
        });
      }
      p();
    });
  return y.createElement(y.Fragment, null, ee({
    ourProps: Z,
    theirProps: s,
    slot: $,
    defaultTag: Pt,
    name: "Popover.Button"
  }), x && !u && i && y.createElement(Pe, {
    id: d,
    ref: n.afterButtonSentinel,
    features: fe.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: o
  }));
}
var ct = "div",
  vt = le.RenderStrategy | le.Static;
function Me(t, l) {
  var P = ne(),
    _t$id2 = t.id,
    R = _t$id2 === void 0 ? "headlessui-popover-backdrop-".concat(P) : _t$id2,
    _t$transition = t.transition,
    T = _t$transition === void 0 ? !1 : _t$transition,
    C = _objectWithoutProperties(t, _excluded3),
    _ae3 = ae("Popover.Backdrop"),
    _ae4 = _slicedToArray(_ae3, 2),
    s = _ae4[0].popoverState,
    n = _ae4[1],
    c = X(null),
    i = q(l, c),
    r = _e(),
    _Re = Re(T, c, r !== null ? (r & z.Open) === z.Open : s === 0),
    _Re2 = _slicedToArray(_Re, 2),
    d = _Re2[0],
    _ = _Re2[1],
    m = A(function (a) {
      if (Fe(a.currentTarget)) return a.preventDefault();
      n({
        type: 1
      });
    }),
    E = I(function () {
      return {
        open: s === 0
      };
    }, [s]),
    u = _objectSpread({
      ref: i,
      id: R,
      "aria-hidden": !0,
      onClick: m
    }, Be(_));
  return ee({
    ourProps: u,
    theirProps: C,
    slot: E,
    defaultTag: ct,
    features: vt,
    visible: d,
    name: "Popover.Backdrop"
  });
}
var Tt = "div",
  mt = le.RenderStrategy | le.Static;
function yt(t, l) {
  var P = ne(),
    _t$id3 = t.id,
    R = _t$id3 === void 0 ? "headlessui-popover-panel-".concat(P) : _t$id3,
    _t$focus = t.focus,
    T = _t$focus === void 0 ? !1 : _t$focus,
    C = t.anchor,
    _t$portal = t.portal,
    s = _t$portal === void 0 ? !1 : _t$portal,
    _t$modal = t.modal,
    n = _t$modal === void 0 ? !1 : _t$modal,
    _t$transition2 = t.transition,
    c = _t$transition2 === void 0 ? !1 : _t$transition2,
    i = _objectWithoutProperties(t, _excluded4),
    _ae5 = ae("Popover.Panel"),
    _ae6 = _slicedToArray(_ae5, 2),
    r = _ae6[0],
    d = _ae6[1],
    _ye2 = ye("Popover.Panel"),
    _ = _ye2.close,
    m = _ye2.isPortalled,
    E = "headlessui-focus-sentinel-before-".concat(P),
    u = "headlessui-focus-sentinel-after-".concat(P),
    a = X(null),
    v = ze(C),
    _Je = Je(v),
    _Je2 = _slicedToArray(_Je, 2),
    L = _Je2[0],
    F = _Je2[1],
    G = Xe();
  v && (s = !0);
  var j = q(a, l, v ? L : null, function (f) {
      d({
        type: 4,
        panel: f
      });
    }),
    b = de(a),
    D = ot();
  Ge(function () {
    return d({
      type: 5,
      panelId: R
    }), function () {
      d({
        type: 5,
        panelId: null
      });
    };
  }, [R, d]);
  var H = _e(),
    _Re3 = Re(c, a, H !== null ? (H & z.Open) === z.Open : r.popoverState === 0),
    _Re4 = _slicedToArray(_Re3, 2),
    O = _Re4[0],
    V = _Re4[1];
  He(O, r.button, function () {
    d({
      type: 1
    });
  });
  var U = r.__demoMode ? !1 : n && O;
  We(U, b);
  var N = A(function (f) {
    var o;
    switch (f.key) {
      case W.Escape:
        if (r.popoverState !== 0 || !a.current || b != null && b.activeElement && !a.current.contains(b.activeElement)) return;
        f.preventDefault(), f.stopPropagation(), d({
          type: 1
        }), (o = r.button) == null || o.focus();
        break;
    }
  });
  re(function () {
    var f;
    t.static || r.popoverState === 1 && ((f = t.unmount) == null || f) && d({
      type: 4,
      panel: null
    });
  }, [r.popoverState, t.unmount, t.static, d]), re(function () {
    if (r.__demoMode || !T || r.popoverState !== 0 || !a.current) return;
    var f = b == null ? void 0 : b.activeElement;
    a.current.contains(f) || w(a.current, k.First);
  }, [r.__demoMode, T, a.current, r.popoverState]);
  var Q = I(function () {
      return {
        open: r.popoverState === 0,
        close: _
      };
    }, [r.popoverState, _]),
    x = Te(v ? G() : {}, _objectSpread({
      ref: j,
      id: R,
      onKeyDown: N,
      onBlur: T && r.popoverState === 0 ? function (f) {
        var e, p, g, S, B;
        var o = f.relatedTarget;
        o && a.current && ((e = a.current) != null && e.contains(o) || (d({
          type: 1
        }), ((g = (p = r.beforePanelSentinel.current) == null ? void 0 : p.contains) != null && g.call(p, o) || (B = (S = r.afterPanelSentinel.current) == null ? void 0 : S.contains) != null && B.call(S, o)) && o.focus({
          preventScroll: !0
        })));
      } : void 0,
      tabIndex: -1,
      style: _objectSpread(_objectSpread(_objectSpread({}, i.style), F), {}, {
        "--button-width": he(r.button, !0).width
      })
    }, Be(V))),
    $ = Ce(),
    J = A(function () {
      var f = a.current;
      if (!f) return;
      function o() {
        K($.current, _defineProperty(_defineProperty({}, h.Forwards, function () {
          var p;
          w(f, k.First) === ce.Error && ((p = r.afterPanelSentinel.current) == null || p.focus());
        }), h.Backwards, function () {
          var e;
          (e = r.button) == null || e.focus({
            preventScroll: !0
          });
        }));
      }
      o();
    }),
    Z = A(function () {
      var f = a.current;
      if (!f) return;
      function o() {
        K($.current, _defineProperty(_defineProperty({}, h.Forwards, function () {
          var M;
          if (!r.button) return;
          var e = ve(),
            p = e.indexOf(r.button),
            g = e.slice(0, p + 1),
            B = [].concat(_toConsumableArray(e.slice(p + 1)), _toConsumableArray(g));
          var _iterator2 = _createForOfIteratorHelper(B.slice()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var ue = _step2.value;
              if (ue.dataset.headlessuiFocusGuard === "true" || (M = r.panel) != null && M.contains(ue)) {
                var be = B.indexOf(ue);
                be !== -1 && B.splice(be, 1);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          w(B, k.First, {
            sorted: !1
          });
        }), h.Backwards, function () {
          var p;
          w(f, k.Previous) === ce.Error && ((p = r.button) == null || p.focus());
        }));
      }
      o();
    });
  return y.createElement(Qe, null, y.createElement(se.Provider, {
    value: R
  }, y.createElement(pe.Provider, {
    value: {
      close: _,
      isPortalled: m
    }
  }, y.createElement(rt, {
    enabled: s ? t.static || O : !1
  }, O && m && y.createElement(Pe, {
    id: E,
    ref: r.beforePanelSentinel,
    features: fe.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: J
  }), ee({
    mergeRefs: D,
    ourProps: x,
    theirProps: i,
    slot: Q,
    defaultTag: Tt,
    features: mt,
    visible: O,
    name: "Popover.Panel"
  }), O && m && y.createElement(Pe, {
    id: u,
    ref: r.afterPanelSentinel,
    features: fe.Focusable,
    "data-headlessui-focus-guard": !0,
    as: "button",
    type: "button",
    onFocus: Z
  })))));
}
var Et = "div";
function bt(t, l) {
  var P = X(null),
    R = q(P, l),
    _ge3 = ge([]),
    _ge4 = _slicedToArray(_ge3, 2),
    T = _ge4[0],
    C = _ge4[1],
    s = A(function (E) {
      C(function (u) {
        var a = u.indexOf(E);
        if (a !== -1) {
          var v = u.slice();
          return v.splice(a, 1), v;
        }
        return u;
      });
    }),
    n = A(function (E) {
      return C(function (u) {
        return [].concat(_toConsumableArray(u), [E]);
      }), function () {
        return s(E);
      };
    }),
    c = A(function () {
      var a;
      var E = tt(P);
      if (!E) return !1;
      var u = E.activeElement;
      return (a = P.current) != null && a.contains(u) ? !0 : T.some(function (v) {
        var L, F;
        return ((L = E.getElementById(v.buttonId.current)) == null ? void 0 : L.contains(u)) || ((F = E.getElementById(v.panelId.current)) == null ? void 0 : F.contains(u));
      });
    }),
    i = A(function (E) {
      var _iterator3 = _createForOfIteratorHelper(T),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var u = _step3.value;
          u.buttonId.current !== E && u.close();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }),
    r = I(function () {
      return {
        registerPopover: n,
        unregisterPopover: s,
        isFocusWithinPopoverGroup: c,
        closeOthers: i
      };
    }, [n, s, c, i]),
    d = I(function () {
      return {};
    }, []),
    _ = t,
    m = {
      ref: R
    };
  return y.createElement(Ae, null, y.createElement(Ee.Provider, {
    value: r
  }, ee({
    ourProps: m,
    theirProps: _,
    slot: d,
    defaultTag: Et,
    name: "Popover.Group"
  })));
}
var gt = Y(dt),
  St = Y(ft),
  At = Y(Me),
  Ct = Y(Me),
  Bt = Y(yt),
  Rt = Y(bt),
  lo = Object.assign(gt, {
    Button: St,
    Backdrop: Ct,
    Overlay: At,
    Panel: Bt,
    Group: Rt
  });
export { lo as Popover, Ct as PopoverBackdrop, St as PopoverButton, Rt as PopoverGroup, At as PopoverOverlay, Bt as PopoverPanel };